import { Box, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";

export function PhotosSection({ imageUrls, t }) {
  if (!imageUrls?.length) {
    return null;
  }

  return (
    <Box
      mb="16px"
      sx={{
        border: "1px solid #C5D0E0",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: baseTheme.colors.neutral,
      }}
    >
      <Typography
        fontWeight={700}
        fontSize="1.05rem"
        color={baseTheme.colors.text}
        mb="12px"
      >
        {t("status.photos")}
      </Typography>
      <Box display="flex" flexWrap="wrap" gap="10px">
        {imageUrls.map((url, index) => (
          <Box
            key={`${url}-${index}`}
            sx={{
              width: "75px",
              height: "75px",
              overflow: "hidden",
              borderRadius: "8px",
              "& img": {
                width: "100%",
                height: "100%",
                objectFit: "cover",
              },
            }}
          >
            <img src={url} loading="lazy" alt="" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
